import React from 'react';
import { Box, styled, TextField } from '@mui/material';

const FormInput = props => {
  return (
    <Box sx={styles.formGroup}>
      {props.formLabel && <label style={styles.formLabel}>{props.formLabel}</label>}
      <TextField
        {...props}
        variant="outlined"
        sx={styles.textField}
        helperText={!!props.error && props.helperText}
        error={!!props.error}
      />
    </Box>
  );
};

const styles = {
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 0 10px',
    '& .MuiOutlinedInput-input': {
      fontFamily: "MontserratRegular",
      padding: '14px',
      borderRadius: '5px',
      borderColor: '#5807FA',
      height: "1.1876em"
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: '5px'
    },
    '& .Mui-error': {
      fontFamily: "MontserratRegular",
    },
    '& .Mui-focused': {
      boxShadow: '0px 0px 0px 1px #5807FA'
    },
  },
  formLabel: {
    fontSize: 14,
    fontFamily: "MontserratMedium",
    paddingBottom: 10
  },
  
  textField: {
    borderRadius: '5px'
  },
};

export default FormInput
